export function keysOfObject<T extends Record<string, string | number>>(
  obj: T
): (keyof T)[] {
  // Object.keys returns a string[]. This helper is a workaround to get types
  // from enums.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return Array.from(Object.keys(obj)) as any;
}
